<template>
  <header class="header w-100">
    <div class="row no-gutters">
      <div class="col col-md-4 pl-3 pt-1 pt-sm-0">
        <a class="logo" href="/" title="My Learning Center">
          <icon icon="mlc" />
        </a>
      </div>

        <template v-if="showMenus">
            <div class="col-md-4 col d-none d-md-flex">
                <div class="text-center w-100" style="padding-top: 10px">
                    <a
                        v-if="showHoursButton"
                        href="#"
                        @click.prevent="showHoursModal()"
                        class="btn btn-outline-light hours-button"
                    >
                        <span class="icon icon-clock"></span>
                        <span class="text">Company Hours</span>
                    </a>
                </div>
            </div>

            <div class="col col-md-4 pt-3 pr-2 pr-sm-3">
                <div class="header-buttons w-100 clearfix">
                    <ProfileMenu />
                    <div class="help-menu float-right mr-2 mr-sm-3 mr-xl-4">
                        <a
                            class="header-button clearfix help-button ga-event"
                            href="#"
                            @click.prevent="helpClicked()"
                            title="Need Help?"
                            data-ga-category="Buttons"
                            data-ga-action="help"
                            data-ga-label="Help"
                        >
                            <span class="icon text-icon">?</span>
                            <span class="text">Help</span>
                        </a>
                    </div>
                    <CartMenu :numItems="cartNumItems" :cost="cartCost" />
	                <div class="hours-menu-button float-right mr-2 mr-sm-3 mr-xl-4 d-md-none d-block">
                        <a
	                        class="header-button clearfix help-button ga-event"
	                        href="#"
	                        @click.prevent="showHoursModal()"
	                        title="Hours"
	                        data-ga-category="Buttons"
	                        data-ga-action="Hours"
	                        data-ga-label="Help"
                        >
	                        <span class="icon icon-clock"></span>
                            <span class="text">Hours</span>
                        </a>
	                </div>
                </div>
            </div>
        </template>
    </div>
  </header>
</template>

<script>
import ProfileMenu from "./partials/ProfileMenu";
import CartMenu from "./partials/CartMenu";
import HelpModal from "./partials/HelpModal";
import ContactModal from "./partials/ContactModal";

export default {
  components: {
    ProfileMenu,
    CartMenu,
    HelpModal,
    ContactModal,
  },
  props: {
    cartNumItems: { type: Number, default: 0 },
    cartCost: { type: String | Number, default: 0.0 },
    showMenus: { type: Boolean, default: true },
  },
  computed: {
    showHoursButton() {
      return this.$root.isLoggedIn && !this.$root.isPublicUser;
    },
  },
  methods: {
    helpClicked() {
      if (this.$root.isLoggedIn) {
        this.$modal(HelpModal)
          .then(() => {})
          .catch(() => {});
      } else {
        this.$modal(ContactModal)
          .then(() => {})
          .catch(() => {});
      }
    },
    showHoursModal() {
      this.$modal("HoursModal", { company: this.$root.company })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
